import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules';
//import router from '../router'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		init: {},
		ready: false,
	},
	getters:{
		getInit(state){
			return state.init
		},
		getReady(state){
			return state.ready
		}
	},
	mutations: {
		setInit(state,val){
			state.init = val
		},
		setReady(state,val){
			state.ready = val
		}
	},
	actions: {
		initClient({ commit, dispatch, state }) {
			axios.get('init')
				.then((response) => {
					commit('setInit', response.data.data)
					commit('setReady', true);
					document.querySelector("body").style.setProperty('--background', state.init.color.background);
					document.querySelector("body").style.setProperty('--main-color', state.init.color.main);
					document.querySelector("body").style.setProperty('--sub-color', state.init.color.sub);
					document.querySelector("body").style.setProperty('--text-color', state.init.color.text);
					document.querySelector("body").style.setProperty('--header-color', state.init.color.header);
					document.querySelector("body").style.setProperty('--header-text-color', state.init.color.header_text);
					document.querySelector("body").style.setProperty('--footer-color', state.init.color.footer);
					document.querySelector("body").style.setProperty('--footer-text-color', state.init.color.footer_text);
					document.querySelector("body").style.setProperty('--button-light-color', state.init.color.button_light);
					document.querySelector("body").style.setProperty('--button-light-text-color', state.init.color.button_light_text);
					document.querySelector("body").style.setProperty('--button-secondary-color', state.init.color.button_secondary);
					document.querySelector("body").style.setProperty('--button-secondary-text-color', state.init.color.button_secondary_text);
					document.querySelector("body").style.setProperty('--button-text', state.init.color.button_text);
				})	
				.catch((err) => {
				});
		},
	},
	modules: modules
})
